export const SEK_AVAILABLE_TRANSLATION_LANGUAGES_BY_AI = ["en-EN","uk-UK","es-ES"]

